// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EntryPointSchema = z.enum(['API_ENDPOINT','AUTH_MECHANISM','WEBHOOK_HANDLER','WEBSOCKET_ENDPOINT','GRAPHQL_RESOLVER','SOAP_ENDPOINT','EXTERNAL_INTEGRATION','MCP_TOOL','OTHER'] as const);

export type EntryPointType = `${z.infer<typeof EntryPointSchema>}`

export default EntryPointSchema;
